import { IconName } from '@infotech-soe/erp-ui-kit';
import { THotKey } from '@infotech-soe/metaschema';

import { Caption, CaptionType } from '../../../models/caption/Caption';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';

import CategoryCommand from './CategoryCommand';

class ShowCategoryCommand extends CategoryCommand<Record<string, any>> {
  constructor(
    commandImpl: CategoryCommandImpl<Record<string, any>>,
    private caption: string,
    private icon?: IconName,
    private menuLabel?: string,
    private hotKey?: THotKey
  ) {
    super(commandImpl);
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.EXTERNAL,
      caption: this.caption,
    };
  }

  public getIcon(): IconName {
    return this.icon ?? 'need-change';
  }

  public getMenuLabel(): string | undefined {
    return this.menuLabel;
  }

  public getHotKey(): THotKey | undefined {
    return this.hotKey;
  }
}

export default ShowCategoryCommand;
